import { lazy } from "react";

const DSAAssociateDetailPage = lazy(() => import("../Component/Employee/DSAAssociateDetailPage"));
const DSAagreement = lazy(() => import("../Component/Role_OL/DSAagreement"));
const DSAAssociateAgreement = lazy(() => import("../Component/Role_OL/DSAAssociateAgreement"));
const DSAListToPromoter = lazy(() => import("../Component/Employee/DSAListToPromoter"));
const TaxInvoiceForCorporateDSA = lazy(() =>
  import("../Component/ChannelToCorporateDSA/TaxInvoiceForCorporateDSA")
);

const corporateDsaRoutes = [
  { path: "/DSA-detail/:id", element: <DSAAssociateDetailPage />, protected: true },
  { path: "/preview-offer-letter/DSAagreement", element: <DSAagreement />, protected: true },
  {
    path: "/preview-offer-letter/DSAAssociateAgreement",
    element: <DSAAssociateAgreement />,
    protected: true,
  },
  { path: "/pending-dsa-associate-list", element: <DSAListToPromoter />, protected: true },
  {
    path: "/tax-invoice-corporate-dsa",
    element: <TaxInvoiceForCorporateDSA />,
    protected: false,
  },
];

export default corporateDsaRoutes;
